import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { i18n } from '../../i18n/translate.js';
import orderBy from 'lodash/orderBy';
import { DashboardCard } from '../DashboardCard/component.js';

var TodoCard = function TodoCard(_ref) {
  var emptyStateImage = _ref.emptyStateImage,
      _onDismiss = _ref.onDismiss,
      _ref$todos = _ref.todos,
      todos = _ref$todos === void 0 ? [] : _ref$todos,
      height = _ref.height;

  var getTodoActionButton = function getTodoActionButton(todo, label, actionName) {
    return {
      label: label,
      style: 'link',
      action: function action() {
        window.location.href = todo.action_link;
      },
      data: {
        action: actionName,
        objectType: 'todo_item',
        objectId: todo.id
      }
    };
  };

  var getCardSpecs = function getCardSpecs(todo) {
    switch (todo.type) {
      case 'Todo::EmailBounceListUpdated':
        return {
          titleIcon: 'envelope',
          title: i18n.t('Bouncing Emails'),
          buttonConfig: [getTodoActionButton(todo, i18n.t('View Bounce List'), 'action-dash-view-email-list')]
        };

      case 'Todo::ReassignmentIssue':
        return {
          titleIcon: 'info',
          title: i18n.t('Reassignment Issue'),
          buttonConfig: [getTodoActionButton(todo, i18n.t('View Assignment'), 'action-dash-view-reassignment')]
        };

      case 'Todo::UserRegistrationBatchFailed':
        return {
          titleIcon: 'accounts',
          title: i18n.t('User Upload Failed'),
          buttonConfig: [getTodoActionButton(todo, i18n.t('Download Error List'), 'action-dash-download-error')]
        };

      case 'Todo::AssignmentDueSoon':
        return {
          titleIcon: 'octagon-exclamation',
          title: i18n.t('Upcoming Due Date'),
          buttonConfig: [getTodoActionButton(todo, i18n.t('View Assignment'), 'action-dash-upcoming-due-date')]
        };
    }
  };

  var getEmptyComponent = function getEmptyComponent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
      src: emptyStateImage
    }), /*#__PURE__*/React.createElement("div", null, i18n.t('You currently have no action items.')), /*#__PURE__*/React.createElement("div", null, i18n.t('Good job!')));
  };

  var orderedTodos = orderBy(todos, ['created_at'], ['desc']);
  return /*#__PURE__*/React.createElement(DashboardCard, {
    type: "todo",
    title: i18n.t('To Do'),
    items: orderedTodos,
    emptyComponent: getEmptyComponent(),
    height: height,
    getItemCardProps: function getItemCardProps(todo) {
      return _objectSpread2({
        description: todo.message,
        dismissable: true,
        onDismiss: function onDismiss() {
          return _onDismiss(todo.id);
        }
      }, getCardSpecs(todo));
    }
  });
};

TodoCard.displayName = "TodoCard";
export { TodoCard };